
import { ArrowCircleRightSharp } from '@mui/icons-material';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Link, useParams, useRouteMatch } from "react-router-dom";
import Scroll from 'react-scroll';
import ConnUrls from '../../Connections/ConnectURL';
import { CurrentPContext, OrderContext } from '../../ContextApi/context';
import OrderFunctions from '../../OrderSettings/OrderFunctions';
import utilsCategurys from '../../_Utils/utilsCategurys';
import utilsSpecialPages from '../../_Utils/utilsSpecialPages';

var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const AllCategurysPage = (props) => {
  const [order, setOrder] = useContext(OrderContext);

  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [loading, setLoading] = useState(true);
  const [allCats, setAllCats] = useState([]);

  let { path, url } = useRouteMatch();

  const history = useHistory();
  const params = useParams();

  useEffect(() => {

    getCurpage();
    //מנקה את ההזמנה 
    setOrder(OrderFunctions.clearOrd());

    props.shoTopStrp(false)
    getCatPage();
    setLoading(false);
  }, [])


  const getCurpage = async () => {
    setCurrentPage(await utilsSpecialPages.getSpecialPageByName("קטגוריות"))
  }


  const getCatPage = async () => {
    let allCatsTemp = await utilsCategurys.getAllCategurys();
    setAllCats(allCatsTemp)

  }
  const goToBack = () => {
    history.goBack();

    // if (document.referrer.indexOf(window.location.host) === -1) {
    // }
    // else {
    //      history.push('/'); }
  }


  return (
    <div className="CatsPage">
      {loading ? "" :
        <>
          <div className={"headOnFixC SecondFont bold big"}>
            {"קטגוריות"}
            <div className={`backSd`}>
              <ArrowCircleRightSharp onClick={() => goToBack()} />
            </div>
          </div>
          <div className={"catsPagelist"}>
            {
              allCats.map((item, index) => {

                // catHead: textBack, catImage: "", catText: ""

                if (item != null) {
                  return (
                    <div key={index} className={"favBtn catsListItem catBtnMasterWrap animate__animated pulseME"}>
                      <Link to={`/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`}>
                        <div className={"imgWrap"}>
                          <div className={"imgDiv"} style={{ backgroundImage: `url("${ConnUrls.servMediasUrl}${item.catImage}")` }} >

                          </div>
                          <div className={"botBlock"}>
                            <div className={"pgBigTxt bold regular"}>
                              {/* <span className={`specDot ${!opHours.openOrCLose ? "specDotClose" : ""}`}><FiberManualRecord /></span> */}
                              {item.catHead}
                            </div>
                            {/* <div className={"pgSmallTxt mediumst"}>
                              {item.buissKitchType}
                            </div>

                            <div className={"pgSmallTxt mediumst"}>
                              <div className={"theImgwrap"} >
                                <div className={"theImg"} style={{ backgroundImage: `url(${ConnUrls.servMediasUrl}PermanentImages/tustus.png")` }}></div>
                              </div>



                              <div className={"timeTxt"}>
                                <div className={"theImg fullWidth"} >
                                  <div className={"onRight"}>
                                    <DirectionsBike />
                                    &nbsp;&nbsp;{priceing} ₪  &nbsp;&nbsp;
                                  </div>

                                  <div className={"onLeft"}>

                                    {(parseInt(timing) + 10) +
                                      " - " + parseInt(timing)} דק'
                                  </div>
                                </div>
                              </div> 
                            </div>
                            */}


                          </div>
                        </div>


                      </Link>
                    </div>
                  )
                }
              })
            }
          </div>
        </>

      }
    </div>
  );
}

export default AllCategurysPage;
